<form [formGroup]="metadataFormGroup">
  <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
    Informations générales
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Masse des salaires</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="totalSalaries"
      />
    </div>
    <div class="col">
      <label i18n>Chiffre d'affaires</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="totalRevenue"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasclaimsLastFiveYears"
          id="hasclaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasclaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasclaimsLastFiveYearsTrue"
          >Oui</label
        >
      </div>
    </div>
  </div>

  <div
    class="row my-3"
    *ngIf="
      metadataFormGroup.value.hasclaimsLastFiveYears === 'true' ||
      metadataFormGroup.value.hasclaimsLastFiveYears === true
    "
  >
    <div class="col">
      <label i18n>Détails des sinistres</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="claims"
      ></textarea>
    </div>
  </div>

  <div class="row row-cols-md-1 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Type de protection juridique</label>
      <select class="form-control" formControlName="legalProtectionType">
        <option *ngFor="let value of legalProtectionTypeValues" [value]="value">
          {{ value }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Personnes assurées
  </div>
  <div formGroupName="insurees">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>L'entreprise et ses collaborateurs</label>
        <div class="form-check">
          <input
            type="radio"
            name="companyAndCollaborators"
            id="companyAndCollaboratorsFalse"
            [value]="false"
            formControlName="companyAndCollaborators"
          />
          <label class="form-check-label" for="companyAndCollaboratorsFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="companyAndCollaborators"
            id="companyAndCollaboratorsTrue"
            [value]="true"
            formControlName="companyAndCollaborators"
          />
          <label class="form-check-label" for="companyAndCollaboratorsTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Les associés</label>
        <div class="form-check">
          <input
            type="radio"
            name="partners"
            id="partnersFalse"
            [value]="false"
            formControlName="partners"
          />
          <label class="form-check-label" for="partnersFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="partners"
            id="partnersTrue"
            [value]="true"
            formControlName="partners"
          />
          <label class="form-check-label" for="partnersTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Les administrateurs</label>
        <div class="form-check">
          <input
            type="radio"
            name="administrators"
            id="administratorsFalse"
            [value]="false"
            formControlName="administrators"
          />
          <label class="form-check-label" for="administratorsFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="administrators"
            id="administratorsTrue"
            [value]="true"
            formControlName="administrators"
          />
          <label class="form-check-label" for="administratorsTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Les membres du comité</label>
        <div class="form-check">
          <input
            type="radio"
            name="commiteeMembers"
            id="commiteeMembersFalse"
            [value]="false"
            formControlName="commiteeMembers"
          />
          <label class="form-check-label" for="commiteeMembersFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="commiteeMembers"
            id="commiteeMembersTrue"
            [value]="true"
            formControlName="commiteeMembers"
          />
          <label class="form-check-label" for="commiteeMembersTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Les membres de la famille sans contrat de travail</label>
        <div class="form-check">
          <input
            type="radio"
            name="contractlessFamilyMembers"
            id="contractlessFamilyMembersFalse"
            [value]="false"
            formControlName="contractlessFamilyMembers"
          />
          <label class="form-check-label" for="contractlessFamilyMembersFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="contractlessFamilyMembers"
            id="contractlessFamilyMembersTrue"
            [value]="true"
            formControlName="contractlessFamilyMembers"
          />
          <label class="form-check-label" for="contractlessFamilyMembersTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Les collaborateurs libres sans contrat de travail</label>
        <div class="form-check">
          <input
            type="radio"
            name="contractlessFreelanceCollaborateurs"
            id="contractlessFreelanceCollaborateursFalse"
            [value]="false"
            formControlName="contractlessFreelanceCollaborateurs"
          />
          <label
            class="form-check-label"
            for="contractlessFreelanceCollaborateursFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="contractlessFreelanceCollaborateurs"
            id="contractlessFreelanceCollaborateursTrue"
            [value]="true"
            formControlName="contractlessFreelanceCollaborateurs"
          />
          <label
            class="form-check-label"
            for="contractlessFreelanceCollaborateursTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Prestations d'assurances
  </div>
  <div formGroupName="coverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>PJ en matière de circulation routière</label>
        <div class="form-check">
          <input
            type="radio"
            name="roadTraffic"
            id="roadTrafficFalse"
            [value]="false"
            formControlName="roadTraffic"
          />
          <label class="form-check-label" for="roadTrafficFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="roadTraffic"
            id="roadTrafficTrue"
            [value]="true"
            formControlName="roadTraffic"
          />
          <label class="form-check-label" for="roadTrafficTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Nombre de véhicules entreprise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="companyVehiclesCount"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>PJ immobilière</label>
        <div class="form-check">
          <input
            type="radio"
            name="realEstate"
            id="realEstateFalse"
            [value]="false"
            formControlName="realEstate"
          />
          <label class="form-check-label" for="realEstateFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="realEstate"
            id="realEstateTrue"
            [value]="true"
            formControlName="realEstate"
          />
          <label class="form-check-label" for="realEstateTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Somme garantie par sinistre</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSumPerClaim"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Somme garantie en matière contractuelle</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSumContracts"
        />
      </div>
      <div class="col">
        <label i18n>Franchise en couverture contractuelle</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductibleContracts"
        />
      </div>
    </div>

    <div class="row row-cols-md-1 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Somme garantie pour la couverture internationale</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSumInternational"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Indemnisation de la perte de salaire due à la procédure</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="earningsLossReimbursement"
            id="earningsLossReimbursementFalse"
            [value]="false"
            formControlName="earningsLossReimbursement"
          />
          <label class="form-check-label" for="earningsLossReimbursementFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="earningsLossReimbursement"
            id="earningsLossReimbursementTrue"
            [value]="true"
            formControlName="earningsLossReimbursement"
          />
          <label class="form-check-label" for="earningsLossReimbursementTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n
          >Indemnisation des frais de déplacement dus à la procédure</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="travelExpensesReimbursement"
            id="travelExpensesReimbursementFalse"
            [value]="false"
            formControlName="travelExpensesReimbursement"
          />
          <label class="form-check-label" for="travelExpensesReimbursementFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="travelExpensesReimbursement"
            id="travelExpensesReimbursementTrue"
            [value]="true"
            formControlName="travelExpensesReimbursement"
          />
          <label class="form-check-label" for="travelExpensesReimbursementTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Contrats portant sur le mobilier de l'entreprise</label>
        <div class="form-check">
          <input
            type="radio"
            name="companyFurnitureContract"
            id="companyFurnitureContractFalse"
            [value]="false"
            formControlName="companyFurnitureContract"
          />
          <label class="form-check-label" for="companyFurnitureContractFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="companyFurnitureContract"
            id="companyFurnitureContractTrue"
            [value]="true"
            formControlName="companyFurnitureContract"
          />
          <label class="form-check-label" for="companyFurnitureContractTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Droit fiscal</label>
        <div class="form-check">
          <input
            type="radio"
            name="taxLaw"
            id="taxLawFalse"
            [value]="false"
            formControlName="taxLaw"
          />
          <label class="form-check-label" for="taxLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="taxLaw"
            id="taxLawTrue"
            [value]="true"
            formControlName="taxLaw"
          />
          <label class="form-check-label" for="taxLawTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Droit du voisinage</label>
        <div class="form-check">
          <input
            type="radio"
            name="neighborhoodLaw"
            id="neighborhoodLawFalse"
            [value]="false"
            formControlName="neighborhoodLaw"
          />
          <label class="form-check-label" for="neighborhoodLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="neighborhoodLaw"
            id="neighborhoodLawTrue"
            [value]="true"
            formControlName="neighborhoodLaw"
          />
          <label class="form-check-label" for="neighborhoodLawTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Expropriation formelle</label>
        <div class="form-check">
          <input
            type="radio"
            name="expropriation"
            id="expropriationFalse"
            [value]="false"
            formControlName="expropriation"
          />
          <label class="form-check-label" for="expropriationFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="expropriation"
            id="expropriationTrue"
            [value]="true"
            formControlName="expropriation"
          />
          <label class="form-check-label" for="expropriationTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Contrats avec les clients et les fournisseurs</label>
        <div class="form-check">
          <input
            type="radio"
            name="customerSupplierContractsLaw"
            id="customerSupplierContractsLawFalse"
            [value]="false"
            formControlName="customerSupplierContractsLaw"
          />
          <label
            class="form-check-label"
            for="customerSupplierContractsLawFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="customerSupplierContractsLaw"
            id="customerSupplierContractsLawTrue"
            [value]="true"
            formControlName="customerSupplierContractsLaw"
          />
          <label class="form-check-label" for="customerSupplierContractsLawTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Prétentions en dommages et intérêts</label>
        <div class="form-check">
          <input
            type="radio"
            name="damagesClaims"
            id="damagesClaimsFalse"
            [value]="false"
            formControlName="damagesClaims"
          />
          <label class="form-check-label" for="damagesClaimsFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="damagesClaims"
            id="damagesClaimsTrue"
            [value]="true"
            formControlName="damagesClaims"
          />
          <label class="form-check-label" for="damagesClaimsTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Droit pénal et droit administratif</label>
        <div class="form-check">
          <input
            type="radio"
            name="criminalLaw"
            id="criminalLawFalse"
            [value]="false"
            formControlName="criminalLaw"
          />
          <label class="form-check-label" for="criminalLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="criminalLaw"
            id="criminalLawTrue"
            [value]="true"
            formControlName="criminalLaw"
          />
          <label class="form-check-label" for="criminalLawTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Droit administratif, autorisation d'exploiter</label>
        <div class="form-check">
          <input
            type="radio"
            name="administrativeLaw"
            id="administrativeLawFalse"
            [value]="false"
            formControlName="administrativeLaw"
          />
          <label class="form-check-label" for="administrativeLawFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="administrativeLaw"
            id="administrativeLawTrue"
            [value]="true"
            formControlName="administrativeLaw"
          />
          <label class="form-check-label" for="administrativeLawTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Conseils juridiques oraux et écrits illimités</label>
        <div class="form-check">
          <input
            type="radio"
            name="legalAdvice"
            id="legalAdviceFalse"
            [value]="false"
            formControlName="legalAdvice"
          />
          <label class="form-check-label" for="legalAdviceFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="legalAdvice"
            id="legalAdviceTrue"
            [value]="true"
            formControlName="legalAdvice"
          />
          <label class="form-check-label" for="legalAdviceTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Droit des assurances sociales et privées</label>
        <div class="form-check">
          <input
            type="radio"
            name="insurancesLaw"
            id="insurancesLawFalse"
            [value]="false"
            formControlName="insurancesLaw"
          />
          <label class="form-check-label" for="insurancesLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="insurancesLaw"
            id="insurancesLawTrue"
            [value]="true"
            formControlName="insurancesLaw"
          />
          <label class="form-check-label" for="insurancesLawTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Droit d'attaquer en justice</label>
        <div class="form-check">
          <input
            type="radio"
            name="legalActionLaw"
            id="legalActionLawFalse"
            [value]="false"
            formControlName="legalActionLaw"
          />
          <label class="form-check-label" for="legalActionLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="legalActionLaw"
            id="legalActionLawTrue"
            [value]="true"
            formControlName="legalActionLaw"
          />
          <label class="form-check-label" for="legalActionLawTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Droit du bail à loyer et à ferme</label>
        <div class="form-check">
          <input
            type="radio"
            name="tenancyLaw"
            id="tenancyLawFalse"
            [value]="false"
            formControlName="tenancyLaw"
          />
          <label class="form-check-label" for="tenancyLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="tenancyLaw"
            id="tenancyLawTrue"
            [value]="true"
            formControlName="tenancyLaw"
          />
          <label class="form-check-label" for="tenancyLawTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Droit du travail</label>
        <div class="form-check">
          <input
            type="radio"
            name="laborLaw"
            id="laborLawFalse"
            [value]="false"
            formControlName="laborLaw"
          />
          <label class="form-check-label" for="laborLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="laborLaw"
            id="laborLawTrue"
            [value]="true"
            formControlName="laborLaw"
          />
          <label class="form-check-label" for="laborLawTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Litiges avec les associations professionnelles</label>
        <div class="form-check">
          <input
            type="radio"
            name="professionalAssociationsDisputes"
            id="professionalAssociationsDisputesFalse"
            [value]="false"
            formControlName="professionalAssociationsDisputes"
          />
          <label
            class="form-check-label"
            for="professionalAssociationsDisputesFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="professionalAssociationsDisputes"
            id="professionalAssociationsDisputesTrue"
            [value]="true"
            formControlName="professionalAssociationsDisputes"
          />
          <label
            class="form-check-label"
            for="professionalAssociationsDisputesTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Transformation intérieure des immeubles de l'entreprise</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="interiorTransformation"
            id="interiorTransformationFalse"
            [value]="false"
            formControlName="interiorTransformation"
          />
          <label class="form-check-label" for="interiorTransformationFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="interiorTransformation"
            id="interiorTransformationTrue"
            [value]="true"
            formControlName="interiorTransformation"
          />
          <label class="form-check-label" for="interiorTransformationTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Litiges en matières de concurrence déloyale</label>
        <div class="form-check">
          <input
            type="radio"
            name="unfairCompetitionDisputes"
            id="unfairCompetitionDisputesFalse"
            [value]="false"
            formControlName="unfairCompetitionDisputes"
          />
          <label class="form-check-label" for="unfairCompetitionDisputesFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="unfairCompetitionDisputes"
            id="unfairCompetitionDisputesTrue"
            [value]="true"
            formControlName="unfairCompetitionDisputes"
          />
          <label class="form-check-label" for="unfairCompetitionDisputesTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>PJ immobilière des locaux de l'entreprise</label>
        <div class="form-check">
          <input
            type="radio"
            name="realEstateLaw"
            id="realEstateLawFalse"
            [value]="false"
            formControlName="realEstateLaw"
          />
          <label class="form-check-label" for="realEstateLawFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="realEstateLaw"
            id="realEstateLawTrue"
            [value]="true"
            formControlName="realEstateLaw"
          />
          <label class="form-check-label" for="realEstateLawTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Servitudes et charges foncières</label>
        <div class="form-check">
          <input
            type="radio"
            name="landCharges"
            id="landChargesFalse"
            [value]="false"
            formControlName="landCharges"
          />
          <label class="form-check-label" for="landChargesFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="landCharges"
            id="landChargesTrue"
            [value]="true"
            formControlName="landCharges"
          />
          <label class="form-check-label" for="landChargesTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Opposition contre les permis de construire</label>
        <div class="form-check">
          <input
            type="radio"
            name="constructionPermitOpposition"
            id="constructionPermitOppositionFalse"
            [value]="false"
            formControlName="constructionPermitOpposition"
          />
          <label
            class="form-check-label"
            for="constructionPermitOppositionFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="constructionPermitOpposition"
            id="constructionPermitOppositionTrue"
            [value]="true"
            formControlName="constructionPermitOpposition"
          />
          <label class="form-check-label" for="constructionPermitOppositionTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>PJ internet</label>
        <div class="form-check">
          <input
            type="radio"
            name="internetProtection"
            id="internetProtectionFalse"
            [value]="false"
            formControlName="internetProtection"
          />
          <label class="form-check-label" for="internetProtectionFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="internetProtection"
            id="internetProtectionTrue"
            [value]="true"
            formControlName="internetProtection"
          />
          <label class="form-check-label" for="internetProtectionTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Défense du droit à l'image</label>
        <div class="form-check">
          <input
            type="radio"
            name="imageRights"
            id="imageRightsFalse"
            [value]="false"
            formControlName="imageRights"
          />
          <label class="form-check-label" for="imageRightsFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="imageRights"
            id="imageRightsTrue"
            [value]="true"
            formControlName="imageRights"
          />
          <label class="form-check-label" for="imageRightsTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Droits des marques - Droits d'auteur</label>
        <div class="form-check">
          <input
            type="radio"
            name="copyrights"
            id="copyrightsFalse"
            [value]="false"
            formControlName="copyrights"
          />
          <label class="form-check-label" for="copyrightsFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="copyrights"
            id="copyrightsTrue"
            [value]="true"
            formControlName="copyrights"
          />
          <label class="form-check-label" for="copyrightsTrue">Oui</label>
        </div>
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Couvertures territoriales
  </div>
  <div formGroupName="territorialCoverages">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture de base</label>
        <div class="form-check">
          <input
            type="radio"
            name="basicCoverage"
            id="basicCoverageFalse"
            [value]="false"
            formControlName="basicCoverage"
          />
          <label class="form-check-label" for="basicCoverageFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="basicCoverage"
            id="basicCoverageTrue"
            [value]="true"
            formControlName="basicCoverage"
          />
          <label class="form-check-label" for="basicCoverageTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Couverture contractuelle étendue</label>
        <div class="form-check">
          <input
            type="radio"
            name="extendedContractualCoverage"
            id="extendedContractualCoverageFalse"
            [value]="false"
            formControlName="extendedContractualCoverage"
          />
          <label class="form-check-label" for="extendedContractualCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="extendedContractualCoverage"
            id="extendedContractualCoverageTrue"
            [value]="true"
            formControlName="extendedContractualCoverage"
          />
          <label class="form-check-label" for="extendedContractualCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Risque accident</label>
        <div class="form-check">
          <input
            type="radio"
            name="accident"
            id="accidentFalse"
            [value]="false"
            formControlName="accident"
          />
          <label class="form-check-label" for="accidentFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="accident"
            id="accidentTrue"
            [value]="true"
            formControlName="accident"
          />
          <label class="form-check-label" for="accidentTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Risque voyage</label>
        <div class="form-check">
          <input
            type="radio"
            name="trip"
            id="tripFalse"
            [value]="false"
            formControlName="trip"
          />
          <label class="form-check-label" for="tripFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="trip"
            id="tripTrue"
            [value]="true"
            formControlName="trip"
          />
          <label class="form-check-label" for="tripTrue">Oui</label>
        </div>
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>PJ circulation</label>
        <div class="form-check">
          <input
            type="radio"
            name="roadTraffic"
            id="territoryRoadTrafficFalse"
            [value]="false"
            formControlName="roadTraffic"
          />
          <label class="form-check-label" for="territoryRoadTrafficFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="roadTraffic"
            id="territoryRoadTrafficTrue"
            [value]="true"
            formControlName="roadTraffic"
          />
          <label class="form-check-label" for="territoryRoadTrafficTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>PJ immobilière</label>
        <div class="form-check">
          <input
            type="radio"
            name="realEstate"
            id="territoryRealEstateFalse"
            [value]="false"
            formControlName="realEstate"
          />
          <label class="form-check-label" for="territoryRealEstateFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="realEstate"
            id="territoryRealEstateTrue"
            [value]="true"
            formControlName="realEstate"
          />
          <label class="form-check-label" for="territoryRealEstateTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </div>
</form>
